

export const currentOrderAttributes = {
    cs: '5% 12% 10% 15% 15% 10% 10% 8% 10% 5%',
    headers: [
        { title: 'market' },
        { title: 'amount'},
        { title: 'unitPrice', sort: 'priceUnit' },
        { title: 'price', sort: 'price' },
        { title: 'transaction-type' },
        { title: 'trade-type' },
        { title: 'traded-pc' },
        { title: 'date', sort: 'createdAt' }
    ]
}

export const tradeAttributes = {
    cs: '5% 15% 15% 15% 15% 10% 10% 15%',
    headers: [
        {title: 'market'},
        {title: 'amount', sort: 'amount'},
        {title: 'unitPrice', sort: 'priceUnit'},
        {title: 'price', sort: 'price'},
        {title: 'transaction-type'},
        {title: 'trade-type'},
        {title: 'date', sort: 'createdAt'}
    ]
}
